export const AFFIRM_SCRIPT_URL = 'https://cdn1.affirm.com/js/v2/affirm.js';
export const AFFIRM_API_KEY = '7CX281TY4M1UZ4J4';
